import { call, put } from 'redux-saga/effects';
import { ContractAsyncActions } from 'store/actions/contract';
import { apiCall } from 'utils/apiCall';

function* fetch(action) {
  const {
    FetchListingContract: {
      Actions: { SUCCESS, FAILURE },
    },
  } = ContractAsyncActions;

  const {
    payload: { id },
  } = action;

  try {
    const response = yield call(apiCall, `/listings/${id}/contract`, 'get');
    yield put(SUCCESS(response.data));
  } catch (error) {
    yield put(FAILURE(error));
  }
}

export default fetch;
